import React, { type ReactNode } from "react";

import { useToasts } from "react-toast-notifications";

import { IconButton, type IconButtonProps } from "@shared/buttons";

export interface CopyButtonProps
  extends Omit<
    IconButtonProps,
    "children" | "leftIcon" | "rightIcon" | "onClick"
  > {
  readonly children?: ReactNode;
  readonly valueToCopy: string;
  readonly successMessage?: string;
}

export const CopyButton = ({
  valueToCopy,
  children = "Copy",
  successMessage = "Copied to clipboard!",
  ...props
}: CopyButtonProps) => {
  const { addToast } = useToasts();

  return (
    <IconButton
      variant="secondary"
      {...props}
      leftIcon={<i className="fa-regular fa-sharp fa-copy" />}
      onClick={() => {
        window.navigator.clipboard.writeText(valueToCopy);
        addToast(successMessage, { appearance: "success" });
      }}
    >
      {children}
    </IconButton>
  );
};
